import axios, { ApiResponse, ApiRoutes, ErrorResponse } from "@/api/client";
import { EgressIPs } from "@/types";

const getEgressIPs: () => Promise<string[]> = () => {
  return axios
    .get(ApiRoutes.EGRESS_IPS)
    .then((res: ApiResponse<EgressIPs>) => {
      return res.data.data.egress_ips;
    })
    .catch((res: ErrorResponse) => {
      const e = {
        error: {
          message: res.response?.data?.message || "Failed to fetch egress IP address(es).",
          suppressGlobalNotification: true,
          statusCode: res.response?.status,
        },
      };
      throw e;
    });
};

export default getEgressIPs;
